module.exports = __webpack_public_path__ + "img/stretch--genre5_title--sp.817118eb.png";